'use client';

import { usePathname } from 'next/navigation';
import Image from 'next/image';
import { UrlImage } from '@/components/menu/types';
import getDirectusImageUrl from '@/lib/utils/image';
import SocialLinkGradient from '@/components/link/SocialLinkGradient';
import { buildSocialShareLink } from '@/lib/utils/link';
import { useContext } from 'react';
import { CommonDataContext } from 'app/provider/CommonDataProvider';
import mapGlobalsToUrlImages from '@/lib/mappers/mapGlobalsToUrlImages';

const SHAREABLE_SOCIAL_NETWORKS = ['facebook', 'twitter', 'linkedin'];

interface Props {
  title?: string;
  summary?: string;
  horizontal?: boolean;
}

const SOCIAL_WIDTH = 20;
const SOCIAL_HEIGHT = 20;

export default function SocialShare({ title = '', summary = '', horizontal = false }: Props) {
  const {
    global: { data: globalData },
  } = useContext(CommonDataContext)!;

  const pathname = usePathname();
  const url = (item: UrlImage) => buildSocialShareLink(item.url, pathname, title, summary);

  // filter non shareable social items
  const mappedGlobalData = mapGlobalsToUrlImages(globalData);
  const socialItems = mappedGlobalData.socialItems.filter(({ title }) =>
    SHAREABLE_SOCIAL_NETWORKS.includes(title.toLowerCase()),
  );

  return (
    <div
      className={`flex items-center justify-center ${horizontal ? '' : 'flex-row md:flex-col'} gap-2`}
    >
      {socialItems.map((item, index) =>
        item.url ? (
          <SocialLinkGradient key={index} item={item} url={url(item)} style={'light'}>
            <Image
              alt={item.title || ''}
              src={getDirectusImageUrl(item.image_dark || '', true) || ''}
              width={SOCIAL_WIDTH}
              height={SOCIAL_HEIGHT}
            />
          </SocialLinkGradient>
        ) : null,
      )}
    </div>
  );
}
